import React from "react";
import { formatDate } from "common/service/CommonService";
import { formatTime24Hour } from "./sessionlogconstant";

export const renderResultBadge = (result?: string | null) => {
  const resLower = String(result || "").toLowerCase();

  if (resLower === "valid" || resLower === "matched") {
    return (
      <span
        className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2.5 py-1 text-uppercase fw-bold"
        style={{ fontSize: "11px" }}
      >
        <i className="ri-checkbox-circle-line me-1"></i>MATCHED
      </span>
    );
  }

  if (resLower === "skipped") {
    return (
      <span
        className="badge bg-warning bg-opacity-10 text-warning border border-warning border-opacity-25 px-2.5 py-1 text-uppercase fw-bold"
        style={{ fontSize: "11px" }}
      >
        <i className="ri-close-circle-line me-1"></i>SKIPPED
      </span>
    );
  }

  return (
    <span
      className="badge bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25 px-2.5 py-1 text-uppercase fw-bold"
      style={{ fontSize: "11px" }}
    >
      <i className="ri-error-warning-line me-1"></i>MISMATCHED
    </span>
  );
};

export const getAttemptsModalColumns = (type: "collection" | "separation") => {
  const cols = [
    {
      key: "attemptno",
      label: "Attempt #",
      textCenter: true,
      render: (_: any, row: any) => (
        <span className="badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 px-2.5 py-1 font-monospace fw-bold">
          #{row.attemptno || 1}
        </span>
      ),
    },
    {
      key: "vaccutainerbarcode",
      label: "Vacutainer Barcode",
      textCenter: true,
      render: (_: any, row: any) => (
        <div className="font-monospace fw-bold text-dark">
          {row.vaccutainerbarcode || "—"}
        </div>
      ),
    },
  ];

  if (type === "separation") {
    cols.push({
      key: "aliquotbarcode",
      label: "Aliquot Barcode",
      textCenter: true,
      render: (_: any, row: any) => (
        <div className="font-monospace fw-bold text-primary">
          {row.aliquotbarcode || "—"}
        </div>
      ),
    });
  }

  cols.push(
    {
      key: "result",
      label: "Status",
      textCenter: true,
      render: (_: any, row: any) => renderResultBadge(row.result),
    },
    {
      key: "resultmessage",
      label: "Result Message",
      textCenter: true,
      render: (_: any, row: any) => (
        <div className="text-dark small fw-medium">
          {row.resultmessage || "—"}
        </div>
      ),
    },
    {
      key: "scanbyname",
      label: "Scanned By",
      textCenter: true,
      render: (_: any, row: any) => (
        <div className="fw-bold text-dark">{row.scanbyname || "—"}</div>
      ),
    },
    {
      key: "scandate",
      label: "Scanned Date & Time",
      textCenter: true,
      render: (_: any, row: any) => (
        <div className="font-monospace text-dark small fw-medium">
          {row.scandate ? `${formatDate(row.scandate)} (${formatTime24Hour(row.scandate)})` : "—"}
        </div>
      ),
    }
  );

  if (type === "collection") {
    cols.push({
      key: "skipreason",
      label: "Skip Reason",
      textCenter: true,
      render: (_: any, row: any) => (
        <div className="text-muted small">
          {row.skipreason ? String(row.skipreason).trim() : "—"}
        </div>
      ),
    });
  }

  return cols;
};
